import React, { useState, useEffect } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Select from '../../app/components/Select';
import Checkbox from '../../app/components/CheckBox';
import { Tabs } from '../../app/components/Tabs';

const FormEditCollaborator = ({
  isOpen,
  onClose,
  title,
  selectCollaborator,
  onSubmit,
}) => {
  const [activeTab, setActiveTab] = useState('Detalhes');
  const [formData, setFormData] = useState({
    id: '',
    nome: '',
    email: '',
    senha: '',
    genero: '',
    dataNascimento: '',
    telefone: '',
    ativo: false,
    staff: false,
    administrativo: false,
    departamentos: [],
    nivel: '',
    visao: '',
    departamento: '', 
    colaboradorDestino: '',
    tipoTransferencia: 'obrigacao',
  });

  const tabsName = ['Detalhes', 'Departamentos', 'Permissões', 'Transferência'];
  
  const colaboradores = [
    { value: 'Paulo', label: 'Paulo' },
    { value: 'Felipe Mesquita', label: 'Felipe Mesquita' },
    { value: 'José Victor', label: 'José Victor' },
    { value: 'Rayana', label: 'Rayana' },
    { value: 'Barbara Lima', label: 'Barbara Lima' },
    { value: 'Bruna Rodrigues', label: 'Bruna Rodrigues' },
    { value: 'João Victor', label: 'João Victor' },
    { value: 'Regyna Abreu', label: 'Regyna Abreu' },
    { value: 'Ana Célia', label: 'Ana Célia' },
    { value: 'Thaíssa de Almeida Seguins Aguiar', label: 'Thaíssa de Almeida Seguins Aguiar' },
    { value: 'Nathalia Leal', label: 'Nathalia Leal' },
    { value: 'Natallia Marissa', label: 'Natallia Marissa' },
    { value: 'Samuel Mota', label: 'Samuel Mota' },
    { value: 'Patricia Xavier Albuquerque', label: 'Patricia Xavier Albuquerque' },
    { value: 'Polyane Ferreira', label: 'Polyane Ferreira' },
    { value: 'Mariana Lopes', label: 'Mariana Lopes' },
    { value: 'Raquel Campos', label: 'Raquel Campos' },
    { value: 'JARIVAN ALENCAR SANTOS', label: 'JARIVAN ALENCAR SANTOS' },
    { value: 'Maria Victoria', label: 'Maria Victoria' },
  ];

  const departamentoOptions = [
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Recursos Humanos', label: 'Recursos Humanos' },
    { value: 'Desenvolvimento', label: 'Desenvolvimento' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Comercial', label: 'Comercial' },
    { value: 'Executivo', label: 'Executivo' },
    { value: 'Fiscal', label: 'Fiscal' },
    { value: 'Contábil', label: 'Contábil' },
    { value: 'DP', label: 'DP' },
    { value: 'Sucesso do Cliente', label: 'Sucesso do Cliente' },
    { value: 'Legalização', label: 'Legalização' },
    { value: 'Gestão de Riscos', label: 'Gestão de Riscos' },
    { value: 'Gestão para Resultados', label: 'Gestão para Resultados' },
    { value: 'Ordens de Serviços', label: 'Ordens de Serviços' },
  ];

  useEffect(() => {
    if (selectCollaborator) {
      const updatedCollaborator = { ...selectCollaborator };
      
      if (!updatedCollaborator.departamentos) {
        updatedCollaborator.departamentos = updatedCollaborator.departamento 
          ? [updatedCollaborator.departamento] 
          : [];
      }
      
      setFormData(prev => ({ ...prev, ...updatedCollaborator }));
    } else {
      setFormData({
        id: '',
        nome: '',
        email: '',
        senha: '',
        genero: '',
        dataNascimento: '',
        telefone: '',
        ativo: false,
        staff: false,
        administrativo: false,
        departamentos: [],
        departamento: '',
        nivel: '',
        visao: '',
        colaboradorDestino: '',
        tipoTransferencia: 'obrigacao',
      });
    }
  }, [selectCollaborator]);

  const handleChange = (eOrValue, fieldName) => {
    if (
      typeof eOrValue === 'object' &&
      eOrValue !== null &&
      'value' in eOrValue
    ) {
      setFormData((prev) => {
        const updated = { ...prev, [fieldName]: eOrValue.value };
        
        if (fieldName === 'departamento') {
          updated.departamentos = [eOrValue.value, ...prev.departamentos.filter(d => d !== eOrValue.value)];
        }
        
        return updated;
      });
    } else {
      const { name, value, type, checked } = eOrValue.target;
      setFormData((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };

  const renderDetalhes = () => (
    <div className="space-y-6 h-full">
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <span className="font-medium">Informações do Colaborador</span>
        <span className="text-gray-400 text-xs">ⓘ</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        <Input
          label="Nome:"
          name="nome"
          value={formData.nome}
          onChange={handleChange}
          required
        />
        <Select
          label="Gênero:"
          name="genero"
          value={formData.genero}
          onChange={(val) => handleChange(val, 'genero')}
          options={[
            { value: 'Masculino', label: 'Masculino' },
            { value: 'Feminino', label: 'Feminino' },
          ]}
        />
        <Input
          label="Email:"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <Input
          label="Data de nascimento:"
          name="dataNascimento"
          type="date"
          value={formData.dataNascimento}
          onChange={handleChange}
        />
        <Input
          label="Senha:"
          name="senha"
          type="password"
          value={formData.senha}
          onChange={handleChange}
        />
        <Input
          label="Telefone:"
          name="telefone"
          value={formData.telefone}
          onChange={handleChange}
        />
        <Select
          label="Departamento Principal:"
          name="departamento"
          value={formData.departamento}
          onChange={(val) => handleChange(val, 'departamento')}
          options={departamentoOptions}
          required
        />
        <div className="col-span-2">
          <p className="text-sm text-gray-600 mb-2">Configurações:</p>
          <div className="flex flex-col gap-2 pl-1">
            <Checkbox
              title="Ativo"
              name="ativo"
              checked={formData.ativo}
              onChange={handleChange}
            />
            <Checkbox
              title="Staff"
              name="staff"
              checked={formData.staff}
              onChange={handleChange}
            />
            <Checkbox
              title="Administrativo"
              name="administrativo"
              checked={formData.administrativo}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderDepartamentos = () => (
    <div className="space-y-4 h-full">
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <span className="font-medium">Departamentos atribuídos</span>
        <span className="text-gray-400 text-xs">ⓘ</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 overflow-y-auto max-h-96">
        {departamentoOptions.map((dep) => (
          <Checkbox
            key={dep.value}
            title={dep.label}
            name={dep.value}
            checked={formData.departamentos.includes(dep.value)}
            onChange={(e) => {
              const checked = e.target.checked;
              setFormData((prev) => {
                const updatedDeps = checked
                  ? [...prev.departamentos, dep.value]
                  : prev.departamentos.filter((d) => d !== dep.value);
                
                // Se estiver desmarcando o departamento principal, atualiza
                const updatedDep = prev.departamento === dep.value && !checked
                  ? (updatedDeps.length > 0 ? updatedDeps[0] : '')
                  : prev.departamento;
                
                return {
                  ...prev,
                  departamentos: updatedDeps,
                  departamento: updatedDep,
                };
              });
            }}
          />
        ))}
      </div>
    </div>
  );

  const renderPermissoes = () => (
    <div className="h-full flex items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4">
        <Select
          label="Nível"
          name="nivel"
          value={formData.nivel}
          onChange={(val) => handleChange(val, 'nivel')}
          options={[
            { value: 'Assistente', label: 'Assistente' },
            { value: 'Analista', label: 'Analista' },
            { value: 'Coordenador', label: 'Coordenador' },
            { value: 'Gerente', label: 'Gerente' },
            { value: 'Diretor', label: 'Diretor' },
            { value: 'Desenvolvedor', label: 'Desenvolvedor' },
            { value: 'Designer', label: 'Designer' },
          ]}
        />
        <Select
          label="Visão"
          name="visao"
          value={formData.visao}
          onChange={(val) => handleChange(val, 'visao')}
          options={[
            { value: 'Gestor+', label: 'Gestor+' },
            { value: 'Operacional', label: 'Operacional' },
          ]}
        />
      </div>
    </div>
  );

  const renderTransferencia = () => (
    <div className="space-y-6 h-full">
      <div className="flex items-center gap-2 mb-1">
        <span className="text-gray-700 text-sm font-medium">Transferência de Tarefas</span>
        <div className="bg-gray-200 text-gray-600 rounded-full w-5 h-5 flex items-center justify-center text-xs">i</div>
      </div>
      
      <div>
        <p className="mb-2 text-gray-700">Transferir responsabilidades para:</p>
        <Select
          name="colaboradorDestino"
          placeholder="Selecione um colaborador"
          value={formData.colaboradorDestino}
          onChange={(val) => handleChange(val, 'colaboradorDestino')}
          options={colaboradores}
        />
      </div>
      
      <div className="mt-6 space-y-2">
        <label className="flex items-center space-x-2">
          <input
            type="radio"
            id="obrigacao"
            name="tipoTransferencia"
            value="obrigacao"
            checked={formData.tipoTransferencia === 'obrigacao'}
            onChange={(e) => setFormData(prev => ({ ...prev, tipoTransferencia: e.target.value }))}
            className="appearance-none w-4 h-4 border-2 border-[#672c71] cursor-pointer rounded-full relative flex items-center justify-center bg-white checked:bg-white before:content-[''] before:w-2 before:h-2 before:rounded-full before:bg-[#672c71] before:scale-0 before:transition-transform checked:before:scale-100"
          />
          <span className="text-gray-700">Por obrigação</span>
        </label>
        
        <label className="flex items-center space-x-2">
          <input
            type="radio"
            id="tarefa"
            name="tipoTransferencia"
            value="tarefa"
            checked={formData.tipoTransferencia === 'tarefa'}
            onChange={(e) => setFormData(prev => ({ ...prev, tipoTransferencia: e.target.value }))}
            className="appearance-none w-4 h-4 border-2 border-[#672c71] cursor-pointer rounded-full relative flex items-center justify-center bg-white checked:bg-white before:content-[''] before:w-2 before:h-2 before:rounded-full before:bg-[#672c71] before:scale-0 before:transition-transform checked:before:scale-100"
          />
          <span className="text-gray-700">Por tarefa</span>
        </label>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Detalhes':
        return renderDetalhes();
      case 'Departamentos':
        return renderDepartamentos();
      case 'Permissões':
        return renderPermissoes();
      case 'Transferência':
        return renderTransferencia();
      default:
        return null;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submissionData = { ...formData };
    
    if (!submissionData.departamento && submissionData.departamentos.length > 0) {
      submissionData.departamento = submissionData.departamentos[0];
    }
    
    onSubmit(submissionData);
  };

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title}
      className='max-w-4xl'
    >
      <div className="flex items-center gap-4 mb-6">
        <img
          src={`https://i.pravatar.cc/100?u=${selectCollaborator?.id || 'new'}`}
          alt="Avatar"
          className="w-14 h-14 rounded-full"
        />
        <div>
          <h2 className="text-xl font-semibold">{selectCollaborator?.nome || 'Novo Colaborador'}</h2>
          <p className="text-sm text-gray-500">{selectCollaborator?.email || 'Preencha os dados'}</p>
          <p className="text-xs text-indigo-500 cursor-pointer">Editar Colaborador</p>
        </div>
      </div>

      <Tabs
        tabsName={tabsName}
        activeTabName={activeTab}
        onTabClick={setActiveTab}
      />
      
      <div className="mt-6 h-96 overflow-y-auto">
        {renderTabContent()}
      </div>
    </BaseForm>
  );
};

export default FormEditCollaborator;